import React from "react";
import TabPosition from "../shared/TabPosition";
import { Helmet } from "react-helmet-async";
import { TranslationService } from "../../services/TranslationService";
import ConsolidatedActivitySummary from "./components/ConsolidatedActivitySummary";

const ConsolidatedReport: React.FC = () => {
  const { translate } = TranslationService;

  return (
    <TabPosition module="consolidated/report">
      <Helmet>
        <title>
          Intiza - {translate.Consolidated} - {translate.Reports}
        </title>
      </Helmet>
      <section className="dashboard">
        <ConsolidatedActivitySummary />
      </section>
    </TabPosition>
  );
};

export default ConsolidatedReport;
